var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon - Check Mark / Filled / 20",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i7vvllf1ea"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4010",
    d: "M218-1025a9.092 9.092 0 0 0-9 9 9.092 9.092 0 0 0 9 9 9.026 9.026 0 0 0 9-9 8.963 8.963 0 0 0-9-9zm-1.3 12.5-3.2-3.2 1-1 2.2 2.2 4.8-4.8 1 1z",
    transform: "translate(-209 1025)",
    style: {
      clipRule: "evenodd",
      fill: "#368a04"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "lqxfjhw72b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4009",
    d: "M192-992h672v-48H192z",
    transform: "translate(-192 1040)",
    style: {
      fill: "#368a04"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3990",
    style: {
      clipPath: "url(#i7vvllf1ea)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3989",
    transform: "translate(-17 -15)",
    style: {
      clipPath: "url(#lqxfjhw72b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4008",
    d: "M204-1030h28v28h-28z",
    transform: "translate(-192 1040)",
    style: {
      fill: "#368a04"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/Success-Icon.88ff9007a5a7ab98fa4c6e7cde54a13b.svg";
export { ForwardRef as ReactComponent };